module.exports = "/_next/static/images/2d0733e66d6a92585f4babf2aedaac20-device-frame@2x.png";